import { Routes } from '@/api/routes';
import { Errors } from '@/constants/errors';
import { apiClient } from '@/services/apiClient';
import type { PaymentToServerResponse } from '@/types/payment';
import { useMutation } from '@tanstack/react-query';
import { forterDiagnostics } from '@/utils/forterDiagnostics';

export const usePaymentToServer = () => {
  return useMutation({
    mutationFn: async (params: unknown) => {
      try {
        // ACDEV-27224: last statement before this body is JSON.stringify'd
        // straight into fetch() (see ApiClient.post) — the closest FE-only
        // proof that a real token was handed to the browser for THIS call.
        forterDiagnostics.tokenHandedToFetch(Routes.PAYMENT, params);
        const response = await apiClient.post<PaymentToServerResponse>(
          Routes.PAYMENT,
          params as Record<string, unknown>
        );
        if (!response || 'error' in response) {
          throw new Error(Errors.global.failedToSendPayment);
        }
        return response;
      } catch (error: unknown) {
        throw new Error(Errors.global.failedToSendPayment, { cause: error });
      }
    },
  });
};
